import React, { Component } from 'react'
import './index.scss'

class GaOptOut extends Component {
  checkbox = React.createRef()

  state = {
    disableStr: 'ga-disable-UA-1263011-1'
  }

  toggleGaButton = () => {
    if (document.cookie.indexOf(this.state.disableStr + '=true') === -1) {
      document.cookie = this.state.disableStr + '=true; expires=Thu, 31 Dec 2099 23:5959 UTC; path=/';
      window[this.state.disableStr] = true;
    } else {
      document.cookie = this.state.disableStr + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  }

  componentDidMount () {
    window.gaDisableString = this.state.disableStr
    if (document.cookie.indexOf(this.state.disableStr + '=true') > -1 ) {
      window[this.state.disableStr] = true;
    }

    this.checkbox.current.checked =
      document.cookie.indexOf(window.gaDisableString + '=true') === -1
  }

  render () {
    return (
      <div className="ga-opt-out">
        <div className="ga-opt-out__container">
          <div className="toggle-button toggle-button--aava">
            <input ref={this.checkbox} id="toggleButtonLabel" type="checkbox" onChange={this.toggleGaButton} />
            <label htmlFor="toggleButtonLabel" data-on-text="Ein" data-off-text="Aus"></label>
            <div className="toggle-button__icon"></div>
          </div>
          <label htmlFor="toggleButtonLabel">
            Google Analytics
          </label>
        </div>
      </div>
    )
  }
}

export default GaOptOut
